import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";

import { BiChevronLeft } from "react-icons/bi";
import "./searchdropswiper.css";
import "swiper/css";
import "swiper/css/navigation";
import Category from "../SearchItems/Category";
import Product from "../SearchItems/Product";
import Article from "./../SearchItems/Article";
import { Link } from "react-router-dom";

export default function SearchDropSwiper({ active, data, type, searchQuery }) {
  return (
    <Swiper
      navigation={true}
      modules={[Navigation]}
      breakpoints={{
        // when window width is >= 320px
        320: {
          slidesPerView: type === "article" ? 2 : 1,
          spaceBetween: 20,
        },
        400: {
          slidesPerView: type === "article" ? 3 : 2,
          spaceBetween: 30,
        },
        // when window width is >= 480px
        500: {
          slidesPerView: type === "category" ? 2 : type === "product" ? 3 : 4,
          spaceBetween: 30,
        },
        // when window width is >= 640px
        640: {
          slidesPerView: type === "category" ? 3 : type === "product" ? 4 : 4,
          spaceBetween: 20,
        },
        750: {
          slidesPerView: type === "category" ? 3 : 5,
          spaceBetween: 20,
        },
        1025: {
          slidesPerView: type === "category" ? 3 : 4,
          spaceBetween: 20,
        },
      }}
      // slidesPerView={type === "category" ? 3 : 4}
      // spaceBetween={20}
      className="mySwiper drop-swiper"
    >
      {type === "category" &&
        data.map((item, index) => {
          return (
            <SwiperSlide key={index}>
              <div className="search-swiper-card ">
                <Category item={item} active={active} />
                {/* <BiChevronLeft /> */}
              </div>
            </SwiperSlide>
          );
        })}
      {type === "product" &&
        data.map((item, index) => {
          return (
            <SwiperSlide key={index}>
              <div className="search-swiper-card" style={{ height: "175px" }}>
                <Product item={item} active={active} />
                {/* <BiChevronLeft /> */}
              </div>
            </SwiperSlide>
          );
        })}
      {type === "article" &&
        data.map((item, index) => {
          return (
            <SwiperSlide key={index}>
              <div className="search-swiper-card ">
                <Article item={item} active={active} />
                {/* <BiChevronLeft /> */}
              </div>
            </SwiperSlide>
          );
        })}
      {type === "popular" &&
        data.map((item, index) => {
          return (
            <SwiperSlide key={index}>
              <div className="search-swiper-card ">
                <span>{item.title}</span>
                <BiChevronLeft />
              </div>
            </SwiperSlide>
          );
        })}
      {type !== "category" ? (
        <SwiperSlide key={10} style={{ alignSelf: "center" }}>
          <div className="search-swiper-card ">
            <Article more={true} searchQuery={searchQuery} type={type} />
          </div>
        </SwiperSlide>
      ) : (
        ""
      )}
    </Swiper>
  );
}
